import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "intersport-search__grid" }
const _hoisted_2 = ["data-bs-content"]
const _hoisted_3 = { class: "intersport-search__title" }
const _hoisted_4 = {
  key: 0,
  class: "intersport-search__bottom"
}
const _hoisted_5 = ["href"]
const _hoisted_6 = { class: "btn-underline__text" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", {
  class: "icon icon-arrow-right btn-underline__icon",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_8 = ["href"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", {
  class: "icon icon-map btn-underline__icon",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_10 = { class: "btn-underline__text" }
const _hoisted_11 = ["data-bs-content"]
const _hoisted_12 = { class: "intersport-search__title" }
const _hoisted_13 = { class: "intersport-search__dates" }
const _hoisted_14 = { class: "d-flex" }
const _hoisted_15 = { class: "intersport-search__date-label" }
const _hoisted_16 = { class: "intersport-search__date-label" }
const _hoisted_17 = { class: "modal-dialog" }
const _hoisted_18 = { class: "modal-content" }
const _hoisted_19 = { class: "modal-header" }
const _hoisted_20 = { class: "modal-title" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-no-styling btn-close",
  "aria-label": "Close",
  "data-bs-dismiss": "modal"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "icon icon-close" })
], -1)
const _hoisted_22 = { class: "modal-body" }
const _hoisted_23 = { class: "modal-footer" }
const _hoisted_24 = {
  type: "button",
  class: "btn btn-secondary btn-outline btn-icon-text order-2 order-md-1",
  "data-bs-dismiss": "modal"
}
const _hoisted_25 = /*#__PURE__*/_createElementVNode("span", {
  class: "icon icon-close btn-icon-text__icon",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("span", {
  class: "icon icon-check btn-icon-text__icon",
  "aria-hidden": "true"
}, null, -1)

import {ref, watch, computed, onMounted, toRaw} from "vue";
// @ts-ignore
import { ISOStringToDate } from "@elements/date-utils";
// @ts-ignore
import {find} from "@elements/dom-utils";
// @ts-ignore
import {translate} from "@elements/translations";
// @ts-ignore
import Popover from "bootstrap/js/dist/popover";
// @ts-ignore
import Modal from "bootstrap/js/dist/modal";
import CustomSelect from "./components/form-elements/CustomSelect.vue";
import Datepicker from "./components/form-elements/Datepicker.vue";
import {useSearchStore} from "../stores/SearchStore.ts";
import {useProductsStore} from "../stores/ProductStore.ts";
import {usePeopleStore} from "../stores/PeopleStore.ts";
import { SearchStore } from "../types/intersport.ts";
import Toast from "./components/Toast.vue";
import LiveToast from "./components/LiveToast.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'IntersportSearch',
  props: {
    searchJson: {},
    productsRequestUrl: {}
  },
  setup(__props: any) {

const props = __props;

// @ts-ignore
const searchStore = useSearchStore();
const productsStore = useProductsStore();
const peopleStore = usePeopleStore();
const searchNotificationModal = ref();



productsStore.setRequestUrl(props.productsRequestUrl);
searchStore.fillStore(props.searchJson);
let firstPopover: any;

const selectedOption = computed(() => {
  if (searchStore.selectedLocation) {
    return searchStore.selectedLocation.id;
  }

  return '';
});

const SelectLocation = (e: string, isFirstUpdate: boolean) => {
  if (!isFirstUpdate) {
    searchStore.setLocation(e);

    let secondPopover = Popover.getOrCreateInstance(find('.js-popover-interpsort--second'));
    firstPopover.enable();
    firstPopover.hide();
    firstPopover.disable();
    secondPopover.show();
    secondPopover.disable();
  }
}

onMounted(() => {
  firstPopover = Popover.getOrCreateInstance(find('.js-popover-interpsort--first'));
  firstPopover.show();
  firstPopover.disable();
});

async function searchProducts() {
  if(productsStore.getSelectedAvailabilities().length === 0) {
    await searchStore.searchProducts();
    await peopleStore.reloadPeople();
  } else {
    const modal = Modal.getOrCreateInstance(searchNotificationModal.value);
    modal.show();
  }
}

async function reloadSearch() {
  await searchStore.searchProducts(searchNotificationModal.value);
  await peopleStore.reloadPeople();
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: "intersport-search js-popover-interpsort--first",
        "data-bs-placement": "bottom",
        "data-bs-content": _unref(translate)('intersport.select-location-popover-text')
      }, [
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(translate)('intersport.pick-location-text')), 1),
          _createVNode(CustomSelect, {
            id: "location-select",
            name: "location-select",
            label: '',
            options: _unref(searchStore).getLocations(),
            "selected-option": selectedOption.value,
            onChangeValue: _cache[0] || (_cache[0] = (event, isFirst) => SelectLocation(event, isFirst))
          }, null, 8, ["options", "selected-option"])
        ]),
        (Object.keys(_unref(searchStore).selectedLocation).length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("a", {
                href: _unref(searchStore).selectedLocation.detailLink,
                class: "btn btn-underline btn-underline--text-sm"
              }, [
                _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(translate)('intersport.location-detail-link-text')), 1),
                _hoisted_7
              ], 8, _hoisted_5),
              _createElementVNode("a", {
                href: _unref(searchStore).selectedLocation.mapLink,
                target: "_blank",
                class: "btn btn-underline btn-underline--text-sm"
              }, [
                _hoisted_9,
                _createElementVNode("span", _hoisted_10, _toDisplayString(_unref(translate)('intersport.location-map-link-text')), 1)
              ], 8, _hoisted_8)
            ]))
          : _createCommentVNode("", true)
      ], 8, _hoisted_2),
      _createElementVNode("div", {
        class: _normalizeClass('intersport-search js-popover-interpsort--second' + (Object.keys(_unref(searchStore).selectedLocation).length === 0 ? ' disabled' : '')),
        "data-bs-placement": "bottom",
        "data-bs-content": _unref(translate)('intersport.select-dates-popover-text')
      }, [
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_12, _toDisplayString(_unref(translate)('intersport.pick-date-text')), 1),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, _toDisplayString(_unref(translate)('intersport.from')), 1),
              (_openBlock(), _createBlock(Datepicker, {
                id: "from-date",
                name: "from-date",
                "class-name": "form-group--bold",
                label: '',
                placeholder: _unref(translate)('intersport.pick-date-label'),
                disable: toRaw(_unref(searchStore).disabledDates),
                "min-date": _unref(searchStore).generalMinDate,
                "max-date": _unref(searchStore).generalMaxDate,
                key: [_unref(searchStore).disabledDates, _unref(searchStore).generalMinDate, _unref(searchStore).generalMaxDate].toString(),
                "model-value": _unref(searchStore).startDate,
                modelValue: _unref(searchStore).startDate,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(searchStore).startDate) = $event))
              }, null, 8, ["placeholder", "disable", "min-date", "max-date", "model-value", "modelValue"]))
            ]),
            _createElementVNode("div", {
              class: _normalizeClass('d-flex intersport-search__date-wrapper' + ((!_unref(searchStore).startDate && Object.keys(_unref(searchStore).selectedLocation).length > 0) ? ' disabled' : ''))
            }, [
              _createElementVNode("span", _hoisted_16, _toDisplayString(_unref(translate)('intersport.to')), 1),
              (_openBlock(), _createBlock(Datepicker, {
                id: "to-date",
                name: "to-date",
                "class-name": "form-group--bold",
                label: '',
                placeholder: _unref(translate)('intersport.pick-date-label'),
                disable: _unref(searchStore).disabledDates,
                "min-date": _unref(searchStore).minDate,
                "default-date": _unref(searchStore).startDate,
                "max-date": _unref(searchStore).maxDate,
                key: [_unref(searchStore).disabledDates, _unref(searchStore).startDate, _unref(searchStore).minDate, _unref(searchStore).maxDate].toString(),
                "model-value": _unref(searchStore).endDate,
                modelValue: _unref(searchStore).endDate,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(searchStore).endDate) = $event))
              }, null, 8, ["placeholder", "disable", "min-date", "default-date", "max-date", "model-value", "modelValue"]))
            ], 2)
          ])
        ]),
        _createElementVNode("div", {
          class: _normalizeClass('intersport-search__bottom' + ((!_unref(searchStore).endDate && Object.keys(_unref(searchStore).selectedLocation).length > 0) ? ' disabled' : ''))
        }, [
          _createElementVNode("button", {
            class: "btn-no-styling link",
            onClick: searchProducts
          }, _toDisplayString(_unref(translate)('intersport.search-button-text')), 1)
        ], 2)
      ], 10, _hoisted_11)
    ]),
    _createElementVNode("div", {
      class: "modal fade",
      id: "intersport-notification-modal",
      tabindex: "-1",
      "aria-labelledby": "intersport-notification-modal",
      "aria-hidden": "true",
      ref_key: "searchNotificationModal",
      ref: searchNotificationModal
    }, [
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("h5", _hoisted_20, _toDisplayString(_unref(translate)('intersport.modal-notification-title')), 1),
            _hoisted_21
          ]),
          _createElementVNode("div", _hoisted_22, _toDisplayString(_unref(translate)('intersport.modal-notification-text')), 1),
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("button", _hoisted_24, [
              _hoisted_25,
              _createTextVNode(" " + _toDisplayString(_unref(translate)('intersport.modal-cancel')), 1)
            ]),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-primary btn-icon-text order-1 order-md-2",
              onClick: reloadSearch
            }, [
              _hoisted_26,
              _createTextVNode(" " + _toDisplayString(_unref(translate)('intersport.modal-notification-confirm')), 1)
            ])
          ])
        ])
      ])
    ], 512),
    _createVNode(Toast, { store: _unref(searchStore) }, null, 8, ["store"]),
    _createVNode(Toast, { store: _unref(productsStore) }, null, 8, ["store"]),
    _createVNode(Toast, { store: _unref(peopleStore) }, null, 8, ["store"]),
    _createVNode(LiveToast, {
      store: _unref(peopleStore),
      toastTitle: _unref(translate)('intersport.error-title')
    }, null, 8, ["store", "toastTitle"]),
    _createVNode(LiveToast, {
      store: _unref(productsStore),
      toastTitle: _unref(translate)('intersport.error-title')
    }, null, 8, ["store", "toastTitle"])
  ], 64))
}
}

})